<template>
  <div class="page">
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
      </div>
      <div class="page_top_title">
        <span class="page_top_title_txt">选择小区</span>
        <img class="page_top_title_img" src="../../../../assets/house/property/1／6.png">
      </div>
      <span class="page_top_tip">完善小区信息后才可使用物业功能</span>
    </div>
    <div class="content">
      <div class="search_content">
        <van-icon name="search" color="#ADADB8" size="16" />
        <span class="search_txt">搜索小区</span>
      </div>
      <div class="scroller_title_txt">已覆盖小区</div>
      <div class="list">
        <div :class="[id == item.id?'cell_active':'cell']" v-for="(item,index) in propertyList" :key="index"
          @click="selProperty(item.id)">
          <div class="cell_name">{{item.community_name}}</div>
          <div class="cell_address">{{item.address}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        id: '',
        propertyList: [{
            community_name: '阳光城上府',
            address: '杭州市萧山区风情大道东100',
            id: 1
          },
          {
            community_name: '长兴苑小区',
            address: '杭州市萧山区风情大道东100',
            id: 2
          },
          {
            community_name: '朗庭公馆',
            address: '杭州市萧山区风情大道东100',
            id: 3
          },
          {
            community_name: '风景蝶园留园',
            address: '杭州市萧山区风情大道东100',
            id: 4
          },
          {
            community_name: '恒大华府',
            address: '杭州市萧山区风情大道东100',
            id: 5
          },
          {
            community_name: '融创',
            address: '杭州市萧山区风情大道东100',
            id: 6
          }
        ]
      }
    },
    created() {},
    mounted() {

    },
    methods: {
      selProperty(id) {
        this.id = id
        this.$router.push('/house/property/binding2')
      }
    }
  }
</script>

<style lang="less" scoped>
  .page_top {
    height: 181px;
    background: url('../../../../assets/house/property/binding_bg.png') no-repeat right top;
  }

  .sechout {
    height: 44px;
    padding: 15px 15px 15px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .page_top_title {
    padding-left: 30px;
    padding-right: 20px;
    margin-bottom: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .page_top_title_txt {
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 24px;
  }

  .page_top_title_img {
    width: 54px;
  }

  .page_top_tip {
    padding-left: 30px;
    font-size: 14px;
    color: #FFFFFF;
  }

  .content {
    padding-left: 16px;
    padding-right: 16px;

  }

  .search_content {
    width: 100%;
    height: 36px;
    background-color: #EAEAEA;
    margin-top: 15px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .search_txt {
    font-size: 12px;
    font-weight: 400;
    color: #ADADB7;
    line-height: 17px;
    padding-left: 6px;
  }

  .scroller_title_txt {
    font-size: 14px;
    font-weight: 400;
    color: #B3B9BF;
    line-height: 20px;
    margin-bottom: 16px;
  }

  .list {
    height: 300px;
    overflow-y: scroll;
  }

  .cell {
    height: 74px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .cell_active {
    height: 72px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    padding-left: 19px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #26C165;
  }

  .cell_name {
    margin-top: 15px;
    font-size: 15px;
    font-weight: 400;
    color: #181B1F;
    line-height: 21px
  }

  .cell_address {
    margin-bottom: 15px;
    font-size: 12px;
    font-weight: 400;
    color: #B3B9BF;
    line-height: 17px;
  }
</style>